import React from "react";

export default function AdditionalInfo({ register, errors }) {
  const fieldName = "additionalInfo";

  return (
    <div>
      <label className="wdc-field-label" htmlFor={fieldName}>
        Anything else to add?
      </label>
      <textarea
        id={fieldName}
        className="wdc-field"
        rows="3"
        placeholder="Optional — anything else we should know"
        {...register(fieldName, { required: false })}
      />
      {errors[fieldName] && (
        <span className="wdc-error">This field is required</span>
      )}
    </div>
  );
}
